import { Link } from 'react-router-dom';
import LegalLayout, { Section, InfoBox } from './LegalLayout';

export default function LegalNoticePage() {
  return (
    <LegalLayout
      title="Legal Notice"
      subtitle="Aviso legal · Who operates Gromly, as required by Spanish Law 34/2002 (LSSI-CE)."
      lastUpdated="Last updated: October 11, 2026"
      relatedLink={{ to: '/privacy', label: 'Privacy Policy →' }}
    >
      <Section number="0" title="Company Information">
        <p>
          Gromly (www.gromly.io) is a product owned and operated by <strong>VESTIGI PLATFORM, S.L.</strong>,
          a Spanish limited liability company. In compliance with Article 10 of Law 34/2002 on Information
          Society Services and Electronic Commerce (LSSI-CE), we provide the following details:
        </p>
        <InfoBox>
          <p><strong>VESTIGI PLATFORM, S.L.</strong></p>
          <p>NIF: B26661439 · EUID: ES08005.000742075</p>
          <p>Registered office: Passatge Beat F X Ponsa, 11, 08180 Moià (Barcelona), Spain</p>
          <p>Registered in the Registro Mercantil de Barcelona, Sheet (Hoja) B-650587, 1st entry</p>
          <p className="text-slate-500 dark:text-slate-400">
            Email:{' '}
            <a href="mailto:contact@gromly.io" className="text-teal-600 dark:text-teal-400 hover:underline">
              contact@gromly.io
            </a>
          </p>
        </InfoBox>
      </Section>

      <Section number="1" title="Purpose of the Website">
        <p>
          This website presents and gives access to Gromly, a collaborative trip planning application for
          building itineraries, managing bookings, splitting shared expenses and optimizing routes. Use of
          the application is governed by our{' '}
          <Link to="/terms" className="text-teal-600 dark:text-teal-400 hover:underline">Terms of Service</Link>{' '}
          and the processing of personal data by our{' '}
          <Link to="/privacy" className="text-teal-600 dark:text-teal-400 hover:underline">Privacy Policy</Link>.
        </p>
      </Section>

      <Section number="2" title="Intellectual and Industrial Property">
        <p>
          The Gromly name and logo, the source code, design, texts, graphics and other content of this
          website belong to VESTIGI PLATFORM, S.L. or are used under licence. Reproducing, distributing or
          transforming them without prior written authorisation is prohibited, except for personal,
          non-commercial use.
        </p>
        <p>
          Content that users publish in Gromly (such as public itineraries) remains theirs, under the
          licence described in the Terms of Service.
        </p>
      </Section>

      <Section number="3" title="Liability">
        <p>
          We work to keep the information on this website accurate and the service available, but we do not
          guarantee that it is free of errors or interruptions. VESTIGI PLATFORM, S.L. is not liable for
          content on third-party websites linked from Gromly, nor for information about places, prices or
          schedules supplied by third parties.
        </p>
      </Section>

      <Section number="4" title="Applicable Law and Jurisdiction">
        <p>
          This Legal Notice is governed by Spanish law. Any dispute will be submitted to the courts that are
          competent under applicable law; where the user is a consumer, to the courts of their place of
          residence.
        </p>
      </Section>
    </LegalLayout>
  );
}
